var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10.5C19.6875 5.14844 15.3516 0.8125 10 0.8125C4.64844 0.8125 0.3125 5.14844 0.3125 10.5C0.3125 15.8516 4.64844 20.1875 10 20.1875C15.3516 20.1875 19.6875 15.8516 19.6875 10.5ZM10 18.9375C5.35156 18.9375 1.5625 15.1875 1.5625 10.5C1.5625 5.89062 5.3125 2.0625 10 2.0625C14.6094 2.0625 18.4375 5.85156 18.4375 10.5C18.4375 15.1484 14.6484 18.9375 10 18.9375ZM9.49219 15.3437C9.6875 15.5391 9.96094 15.5391 10.1563 15.3437L10.4297 15.0703C10.625 14.875 10.625 14.6016 10.4297 14.4062L7.07031 11.1641H14.5313C14.7656 11.1641 15 10.9687 15 10.6953V10.3047C15 10.0703 14.7656 9.83594 14.5313 9.83594H7.07031L10.4297 6.63281C10.625 6.4375 10.625 6.16406 10.4297 5.96875L10.1563 5.69531C9.96094 5.5 9.6875 5.5 9.49219 5.69531L5 10.1875C4.80469 10.3828 4.80469 10.6562 5 10.8516L9.49219 15.3437Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/BackButton.c99fd04f7bcc22c3834f8ed0902ca71d.svg";
export { ForwardRef as ReactComponent };